async function setupMap(mapEl, data) {
  const { Map, InfoWindow } = await google.maps.importLibrary('maps')
  const { Marker } = await google.maps.importLibrary('marker')
  const { Size } = await google.maps.importLibrary('core')

  const position = {
    lat: data.lat,
    lng: data.lng,
  }

  const map = new Map(mapEl, {
    zoom: 13,
    center: position,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    disableDefaultUI: true,
    scrollwheel: false,
    gestureHandling: 'none',
    styles: [
      {
        featureType: 'all',
        elementType: 'all',
        stylers: [{ saturation: -100 }],
      },
    ],
  })

  const mapMarker = {
    url: "data:image/svg+xml,%3Csvg viewBox='0 0 40 58' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath d='M19.833 0C8.868 0 0 8.868 0 19.833c0 14.875 19.833 36.834 19.833 36.834s19.834-21.959 19.834-36.834C39.667 8.868 30.798 0 19.833 0Zm0 26.917a7.086 7.086 0 0 1-7.083-7.084 7.086 7.086 0 0 1 7.083-7.083 7.086 7.086 0 0 1 7.084 7.083 7.086 7.086 0 0 1-7.084 7.084Z' id='a'/%3E%3C/defs%3E%3Cg transform='translate(.167 .667)' fill='none' fill-rule='evenodd'%3E%3Cpath d='M19.833 0C8.868 0 0 8.868 0 19.833c0 14.875 19.833 36.834 19.833 36.834s19.834-21.959 19.834-36.834C39.667 8.868 30.798 0 19.833 0Zm0 26.917a7.086 7.086 0 0 1-7.083-7.084 7.086 7.086 0 0 1 7.083-7.083 7.086 7.086 0 0 1 7.084 7.083 7.086 7.086 0 0 1-7.084 7.084Z' fill='%23C2D1D9'/%3E%3Cmask id='b' fill='%23fff'%3E%3Cuse xlink:href='%23a'/%3E%3C/mask%3E%3Cpath fill='%23C11731' fill-rule='nonzero' mask='url(%23b)' d='M-14.167-5.667h68v68h-68z'/%3E%3Cellipse fill='%23C11731' fill-rule='nonzero' cx='20.333' cy='21.833' rx='11.5' ry='10.5'/%3E%3Cpath fill='%23FFF' fill-rule='nonzero' d='M13.508 17.416h-1.675l7.92 16.917 8.08-17h-1.591l-6.449 13.864z'/%3E%3C/g%3E%3C/svg%3E",
    scaledSize: new Size(40, 56),
  }

  const marker = new Marker({
    map: map,
    title: 'Get Directions',
    position,
    panPosition: position,
    icon: mapMarker,
  })

  const infoWindow = new InfoWindow({
    content: `<div class="map-info"><div class="map-info-content richtext wysiwyg">${data.content}</div></div>`,
    pixelOffset: new Size(0, -8),
  })

  infoWindow.open({ map, anchor: marker })

  if (data.url) {
    marker.addListener('click', () => {
      window.open(data.url, '_blank')
    })
  }
}

document.querySelectorAll('.element-map').forEach((el) => {
  const mapEl = el.querySelector('.google-map-container')
  const data = JSON.parse(mapEl.dataset.json)

  setupMap(mapEl, data)
})
